import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/unidades-policiacas/';

/**
 * GET UnidadesPoliciacas
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getUnidadesPoliciacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Unidad Policiaca
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getUnidadPoliciaca = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Unidad Policiaca
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUnidadPoliciaca = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH UnidadPoliciaca
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchUnidadPoliciaca = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE UnidadPoliciaca
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteUnidadPoliciaca = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
